<template>
    <c-dialog ref="dialog" title="采购单账单详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div v-if="detailData.purchase_code" class="m-detail-tag flex-center-cross">
                <label>{{ detailData.purchase_code }}</label>
                <!--结算状态-->
                <c-state async tag dict="PURCHASE_SETTLE_STATE" :value="detailData.settle_state"></c-state>
            </div>
        </template>

        <module>
            <module-col size="400">
                <c-detail class="m-detail-form">
                    <c-detail-item label="采购单号">
                        {{ detailData.purchase_code }}
                    </c-detail-item>
                    <c-detail-item label="采购类型">
                        <!--采购单类型-->
                        <c-state tag async dict="PURCHASE_ORDER_TYPE" :value="detailData.purchase_type"></c-state>
                    </c-detail-item>
                    <c-detail-item label="采购数(台)">
                        {{ detailData.purchase_count }}
                    </c-detail-item>
                    <c-detail-item label="入库数(台)">
                        {{ detailData.instorage_count }}
                    </c-detail-item>
                    <c-detail-item label="结算数(台)">
                        {{ detailData.settle_count }}
                    </c-detail-item>
                    <c-detail-item label="结算金额">
                        ￥{{ detailData.settle_money }}
                    </c-detail-item>
                    <c-detail-item label="退库数(台)">
                        {{ detailData.out_storage_count }}
                    </c-detail-item>
                    <c-detail-item label="扣款金额">
                        <span v-if="detailData.deduct_money" style="color: red">￥{{ detailData.deduct_money || '-' }}</span>
                    </c-detail-item>

                    <c-detail-item label="供应商">
                        {{ detailData.supplier_name || '-' }}
                    </c-detail-item>
                    <c-detail-item label="供应商联系人">
                        {{ detailData.supplier_contact_realname || '-' }}
                    </c-detail-item>
                    <c-detail-item label="回收金额">
                        ￥{{ detailData.purchase_money }}
                    </c-detail-item>
                    <c-detail-item label="采购部门">
                        {{ detailData.purchase_dept_name || '-' }}
                    </c-detail-item>
                    <c-detail-item label="采购人">
                        {{ detailData.purchase_user_realname || '-' }}
                    </c-detail-item>
                    <c-detail-item label="创建人">
                        {{ detailData.create_user_realname || '-' }}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{ detailData.create_date || '-' }}
                    </c-detail-item>
                </c-detail>
            </module-col>

            <module-col tab-type="border-tab">
                <module-tab name="采购商品" enable-flex>
                    <div class="m-detail-box">
                        <c-table ref="productListTable" :data="productList" border :paging="false">
                            <c-table-column label="商品信息" width="250">
                                <template #default="{data}">
                                    <span>{{getProductText(data)}}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="背贴码" width="150">
                                <template #default="{data}">
                                    <span>{{ data.produce_unique_code || '-' }}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="IMEI码" width="150">
                                <template #default="{data}">
                                    <span>{{ data.produce_imei || '-' }}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="结算状态" width="80">
                                <template #default="{data}">
                                    <c-state async tag dict="PURCHASE_SETTLE_STATE" :value="data.settle_state"></c-state>
                                </template>
                            </c-table-column>

                            <c-table-column label="采购价" width="100">
                                <template #default="{data}">
                                    <span>￥{{ data.purchase_price || '-' }}</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="结算金额" width="100">
                                <template #default="{data}">
                                    <span v-if="data.settle_state == 2 && data.settled_amount" style="color: green">￥{{ data.settled_amount || '-' }}</span>
                                    <span v-else>-</span>
                                </template>
                            </c-table-column>

                            <c-table-column label="扣款金额" width="100">
                                <template #default="{data}">
                                    <span v-if="data.refund_amount" style="color: red">￥{{ data.refund_amount || '-' }}</span>
                                    <span v-else>-</span>
                                </template>
                            </c-table-column>
                        </c-table>
                    </div>
                </module-tab>
            </module-col>
        </module>
    </c-dialog>
</template>

<script>

export default {
    name: 'purchaseBillDetail',

    components: {
    },

    props: {
        id: [String, Number]
    },

    data() {
        return {
            purchase_order_id: 0,
            detailData: {},
            productList: []
        }
    },

    computed: {},

    methods: {
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },
        /**
         * 加载详情
         */
        detail() {
            this.request({
                url: '/financial/purchase/bill/detail',
                data: {
                    purchase_order_id: this.purchase_order_id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.productList = data.productList || [];
                }
            });
        },

        open() {
            this.purchase_order_id = this.id;
            this.detail();
            this.$refs.dialog.open();
        }
    }
}
</script>

<style lang="stylus" scoped>
.logs-list {
    padding: 10px 10px;

    li {
        padding: 4px 0;
        line-height: 16px;
        font-size: 13px;
        color: #666;
    }
}
</style>